<template>
  <div>
    <div class="container-fluid">
      <div v-if="isGetVin" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
    </div>
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>

        <!-- Start the code for this screen here -->
        <div
          class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 pt-5 ml-4 menu-margin-top justify-content-center-sm vinContainer"
        >
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
            <div class="d-flex justify-content-between my-0 py-0">
            <label id="vinlabel" class="col-form-label col-form-label-sm required"
              >VIN</label
            >
            <span v-if="vinError" class="validationError pt-2">{{ vinError }}</span>
            </div>
            
            <div class="custom-input-container">
            <input
              id="vin"
              class="form-control input-sm inputVin"
              @focus="showVin = true"
              @blur="hideVin"
              placeholder="Enter VIN"
              v-model="searchVin"
              @input="debouncesuggestion"
              :class="{'input-error': vinError || isVINEmpty}"
              autocomplete="off"
            />
            
            <ul v-if="vinList.length && showVin" class="reasonList">
              <li
                v-for="vin in vinList"
                :key="vin.vinNumber"
                @click="selectVin(vin.vinNumber,vin.id)"
              >
                {{ vin.vinNumber }}
              </li>
            </ul>
            
          </div>
          <p v-if="isVINEmpty" class="validationError mt-1">
            This VIN does not exist. Do you want to 
            <a href="#" @click="toggleAddVIN" class="addVIN"><strong>Add the VIN</strong></a>
          </p>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
            <div class="d-flex justify-content-between">
              <label id="reasonlabel" class="col-form-label col-form-label-sm required"
              >Reason</label
            >
            <span v-if="reasonError" class="validationError pt-2">{{ reasonError }}</span>
            </div>
            
            <div class="custom-input-container">
            <input
              id="reason"
              name="reason"
              type="text"
              class="form-control input-sm inputVin"
              :class="{'input-error': reasonError}"
              placeholder="Select a Reason"
              v-model="searchQuery"
              @focus="showList = true"
              style="cursor:pointer"
              @blur="hideList"
              readonly
            />
            <img @click="showList = true" src="../assets/arrow.svg" alt="Dropdown Arrow" class="dropdown-arrow" />
            <ul v-if="showList" class="reasonList">
              <li
                v-for="reason in reasons"
                :key="reason"
                @click="selectReason(reason)"
              >
                {{ reason }}
              </li>
            </ul>
            </div>
            <!-- <p v-if="reasonError" class="validationError">{{ reasonError }}</p> -->
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3" v-if="searchQuery == 'Other'">
            <div class="d-flex justify-content-between">
            <label id="notesLabel" class="col-form-label col-form-label-sm"
              >Notes</label
            >
            <span v-if="noteError" class="validationError pt-2 pr-1">{{ noteError }}</span>
            </div>
            <input
              id="notes"
              name="notes"
              type="text"
              class="form-control input-sm inputVin"
              :class="{'input-error': noteError}"
              placeholder="Type reason for blacklisting..."
              v-model="enterNote"
              maxlength="200"
              @paste="handlePaste"
              @input="validateNote"
            />
            <!-- <p v-if="noteError" class="validationError">{{ noteError }}</p> -->
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-2 btnContainer">
            <button
              type="submit"
              @click="handleSubmit"
              class="btn btn-primary addbtn"
            >
              Add to blacklist
            </button>
          </div>
        </div>
        <!-- <div
          class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 pt-5 ml-4 mt-5 justify-content-between vinContainer"
        > -->
        <div
          class="row row-cols-lg-12 row-cols-md-4 row-cols-2 pt-5 ml-4 mt-5 justify-content-between vinContainer"
        >
          <div
            class="col-12 col-md-5 col-lg-4 headingContainer d-flex align-items-center"
          >
            <p class="vehicleHeading">
              Blacklisted Vehicle({{ blackList.totalElements }})
            </p>
          </div>
          <div class="col-12 col-md-4 col-xl-3 mr-4  search-container">
            <input
              id="searchV"
              class="form-control input-sm searchfield"
              placeholder="Enter VIN"
              v-model="searchVinInList"
              @input="debounceInList"
            />
            <img
              src="../assets/Magnifying_Glass.png"
              alt=""
              class="searchLogo"
            />
          </div>
          <div class="col-12 col-md-12">
            <p class="clearText"><a @click="clearSearch()">Clear Search</a></p>
          </div>
          
          <div class="col-12 col-md-12 tablecontainer">
            <table class="table table-responsive-sm tablelist">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" style="width: 30%">
                    VIN(Vehicle identification number)
                  </th>
                  <th scope="col" style="width: 100%">Reason of blocking</th>
                  <th scope="col" style="text-align: end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in blackList.content" :key="item.id">
                  <td class="first align-middle">{{ index + 1 }}</td>
                  <td class="second align-middle">{{ item.vinNumber }}</td>
                  <td class="third">{{ item.blacklistReason }}</td>
                  <td class="fourth">
                    <button
                      class="updatebutton"
                      @click="toggleDropdown($event,index,item)"
                    >
                     . . . 
                    </button>
                    <div  v-if="dropdownIndex == index" class="dropList">
                      <ul>
                        <li @click="openEditDialog" class="editoption">Edit</li>
                        <li @click="openwhitedialog">Whitelist</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <template v-if="isLoading">
                        <div class="d-flex justify-content-center align-items-center">
                          <strong>Loading...</strong>
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
              </template>
          </div>
          
        </div>
        <div class="mt-5">
      
      <b-pagination align="center" v-if="rows>perPage || blackList.length"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        @input="pagination"
        class="customPagination"
      ></b-pagination>
    </div>
        <!-- End of the code for this screen here -->
        <!--confirm blacklist dialog code-->
        <div v-if="isDialog" class="modal" id="blacklistModal">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/Group25.png" alt="" class="logo" />
              <p class="modalText">
                Do you really want to blacklist<br />
                this vehicle?
              </p>
              <button type="button" @click="blacklistEdit()" class="btn okBtn">Blacklist Vehicle</button>
              <button
                type="button"
                class="btn cancelBtn"
                @click="isDialog = false"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <!--confirm blacklist dialog code end-->
        <!--edit dialog code-->
        <div @click.self="closePopup" v-if="editDialog" class="modal" id="editModal">
          <div class="editmodal-content">
            <div class="editmodal-body">
              <div class="d-flex justify-content-between align-item-center">
              <p class="editmodal-Heading">Edit VIN</p>
              <button class="crossBtn" @click="editDialog=false">&times;</button>
              </div>
              <label id="vineditlabel"
              >VIN</label
            >
            <input
              id="editvin"
              class="form-control input-sm inputVin"
              placeholder="Enter VIN"
              v-model="editVinNumber"
              readonly
            />
            <label id="editreasonlabel" class="col-form-label col-form-label-sm"
              >Reason</label
            >
            <div class="custom-input-container">
            <input
              id="editreason1"
              name="editreason"
              type="text"
              class="form-control input-sm inputVin"
              placeholder="Select a Reason"
              v-model="editSearchQuery"
              @focus="editShowList = true"
              @blur="editHideList"
              readonly
              style="cursor:pointer"
            />
            <img @click="editShowList = true" src="../assets/arrow.svg" alt="Dropdown Arrow" class="dropdown-arrow" />
            <ul v-if="editShowList" class="reasonList editscroll">
              <li
                v-for="reason in reasons"
                :key="reason"
                @click="selectEditReason(reason)"
              >
                {{ reason }}
              </li>
            </ul>
            </div>

            <label id="editremarklabel" v-if="editSearchQuery == 'Other'"
              >Note</label
            >
            <textarea v-if="editSearchQuery == 'Other'"
              id="editremark" rows="2" cols="50"
              class="form-control input-sm"
              v-model="editRemark"
              maxlength="200"
              :class="{'input-error': editNoteError}"
              @paste="handleEditPaste"
              @input="validateEditNote"
            ></textarea>
            <p v-if="editNoteError" class="validationError">{{editNoteError}}</p>
            <button class="saveBtn" @click="updateVin()">Save</button>
            </div>
          </div>
        </div>
        <!--edit dialog code end-->
        <!--confirm whitelist dialog code-->
        <div @click.self="isWhiteDialog = false" v-if="isWhiteDialog" class="modal" id="whitelistModal">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/Group26.png" alt="" class="logo" />
              <p class="modalText">
                Do you really want to whitelist<br />
                this vehicle?
              </p>
              <button type="button" @click="whiteList()" class="btn whiteListBtn">Whitelist Vehicle</button>
              <button
                type="button"
                class="btn cancelBtn"
                @click="isWhiteDialog = false"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <!--confirm whitelist dialog code end-->
        <!--successful done dialog code start-->
        <div v-if="isSuccess" class="modal" id="successModal" @click.self="closeSuccess()">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/checkicon-min.png" alt="" class="logo" />
              <p class="modalText">
               VIN is {{successType}} successfully
              </p>
            </div>
          </div>
        </div>
        <!--successful done dialog code end-->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";
import debounce from "lodash/debounce";
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: 'vinBlacklist',
  data() {
    return {
      isSuccess: false,
      successType: '',
      currentPage: 1,
      rows: 0,
      perPage: 10,
      vinSelected: false,
      vinError: '',
      reasonError: '',
      noteError: '',
      editNoteError: '',
      isWhiteDialog: false,
      editVinNumber: '',
      editRemark: '',
      vinId:'',
      editDialog: false,
      dropdownIndex: null,
      count: 0,
      blackList: [],
      isDialog: false,
      showVin: false,
      enterNote: '',
      searchVinInList: '',
      searchVin: '',
      searchQuery: '',
      editSearchQuery: '',
      showList: false,
      editShowList: false,
      vinList: [],
      isLoading: false,
      isGetVin: false,
      alreadyBlacklist: false,
      reasons: [
        "TMU",
        "Unreported Accident",
        "CarFax",
        "Emission System",
        "Previous Rental",
        "Other",
      ],
      isVINEmpty: '',
    };
  },
  methods: {
    toggleDropdown (event, index, item) {
      this.dropdownIndex = this.dropdownIndex === index ? null : index
      this.editVinNumber = item.vinNumber;
      if(this.reasons.includes(item.blacklistReason) && item.blacklistReason!='Other') {
          this.editSearchQuery = item.blacklistReason
      }else {
        this.editSearchQuery = 'Other'
          this.editRemark = item.blacklistReason
      }
      
      this.vinId = item.id
      this.editDialog = false
    },
    openEditDialog () {
      this.editDialog = true
      this.dropdownIndex = null; // Close the dropdown when opening edit dialog
    },
    openwhitedialog () {
      this.isWhiteDialog = true
      this.dropdownIndex = null
    },
    closePopup () {
      this.dropdownIndex = null
      this.editDialog =false
      this.editNoteError = ''
    },
    handleClickOutside (event) {
      const popup = this.$el.querySelector('.dropList')
      if (
        popup &&
        !popup.contains (event.target) &&
        !event.target.classList.contains('updatebutton')
      ) {
        this.closePopup ()
      }
    },
    async getVin () {
      this.isGetVin = true
      this.vinSelected = false
      this.alreadyBlacklist = false
      // this.vinId = ''
      try {
        const response = await httpcommon.get(
          'vinblacklist/filterVinList?type=whitelisted&vinNumber=' + this.searchVin.toUpperCase()
        );
        if(response.data.content.length > 0){
        this.isGetVin = false
        this.vinList = response.data.content
        this.vinSelected = false;
        this.isVINEmpty = false;
        const validId = this.vinList.find(vin => vin.vinNumber === this.searchVin)
        if(validId){
          this.vinId = validId.id
          this.vinError = ''
        } 
        } else {
          httpcommon.get('vinblacklist/filterVinList?type=blacklisted&vinNumber=' + this.searchVin.toUpperCase())
          .then(response=>{
            this.isGetVin = false
            this.vinList = []
            if(response.data.content.length) {
              this.isVINEmpty = false;
              this.alreadyBlacklist = response.data.content.find(vin => vin.vinNumber === this.searchVin)
            } else {
                this.isVINEmpty = true;
              }
          })
        }
        
        // console.log(this.vinList, "vinlist")
      } catch (error) {
        this.isGetVin = false
        this.vinList = []
        console.log(error)
      }
    },

    debouncesuggestion: debounce(function () {
      if (this.searchVin.trim() !== '') {
        this.getVin()
      } else {
        this.vinList = []
      }
    }, 300),

    selectVin (vin,vinId) {
      this.vinId=vinId
      this.searchVin = vin
      this.vinList = []
      this.showVin = false
      this.vinSelected = true
      this.vinError = ''
    },
    hideVin () {
      setTimeout(() => {
        // this.vinList=[]
        this.showVin = false
      }, 200)
    },

    hideList () {
      setTimeout(() => {
        this.showList = false
      }, 200)
    },
    editHideList () {
      setTimeout(() => {
        this.editShowList = false
      }, 200)
    },
    selectReason (reason) {
      this.searchQuery = reason
      this.showList = false
      this.reasonError = ''
      if(reason!='Other') {
        this.enterNote = ''
        this.noteError = ''
       }
    },
    selectEditReason (reason) {
      this.editSearchQuery = reason
      this.showEditList = false
      if(reason!='Other') {
        this.editNoteError = ''
        this.editRemark = ''

      }
    },
    handleSubmit () {
    this.validateVin()
    this.validateReason()
    this.validateNote()
    
    if (!this.vinError && !this.reasonError && !this.noteError) {
      // Form is valid, proceed with submission
      this.isDialog = true
    }
  },

    blacklistEdit () {
      if(this.searchQuery=='Other') {
        this.searchQuery = this.enterNote
      }
      console.log(this.searchQuery)
      let sendData = {
        blacklistReason: this.searchQuery,
        blacklisted: true
      }
      httpcommon.put('/vinblacklist/updateVinDetails?id='+this.vinId,sendData)
    .then(response=>{
      this.searchVinInList = ''
      this.isDialog=false
      this.editDialog = false
      this.debounceInList()
      this.searchQuery=''
      this.editRemark=''
      this.vinId=''
      this.vinList = []
      this.searchVin=''
      this.enterNote=''
      this.isSuccess = true
      this.successType = 'blacklisted'
      setTimeout(()=>{
      this.isSuccess = false
    },2000)
    })
    .catch(error=>{
        this.editDialog = false
        this.errorslist.push(error)
        this.isDialog=false
        this.editRemark=''
    })
    },
     
    validateVin () {
    if (!this.searchVin) {
      this.vinError = '*Please enter a valid VIN'
    } else if (!this.vinSelected && !this.alreadyBlacklist) {
      const isValid = this.vinList.find(vin => vin.vinNumber === this.searchVin)
      if (!isValid) {
        this.vinError = '*Please enter a valid VIN'
      } else {
        // this.vinError = '*Please select the vin from list'
        this.vinError = ''
        // this.vinId = isValid.id
      }
    } else if (this.alreadyBlacklist) {
        this.vinError = '*This Vin is already blacklisted'
      }
     else {
      this.vinError = ''
    }
  },
  validateReason () {
    if (!this.searchQuery) {
      this.reasonError = '*Please enter a valid reason'
    } else {
      this.reasonError = ''
    }
  },
  validateNote () {
    if (this.searchQuery === 'Other' && !this.enterNote.trim()) {
      this.noteError = '*Please enter a valid note'
    }else if (this.enterNote.length > 200) {
        this.noteError = '*Maximum length of 200 characters.'
      } else {
      this.noteError = ''
    }
  },
  handlePaste (event) {
      const pastedData = (event.clipboardData || window.clipboardData).getData('text')

      if (this.enterNote.length + pastedData.length > 200) {
        event.preventDefault()
        this.noteError = '*Maximum length of 200 characters.'
      } else {
        this.noteError = ''
      }
    },
     validateEditNote () {
    if (this.editSearchQuery === 'Other' && !this.editRemark.trim()) {
      this.editNoteError = '*Please enter a valid note"'
    }else if (this.editRemark.length > 200) {
        this.editNoteError = '*Maximum length of 200 characters.'
      } else {
      this.editNoteError = ''
    }
  },
  handleEditPaste (event) {
      const pastedData = (event.clipboardData || window.clipboardData).getData('text')

      if (this.editRemark.length + pastedData.length > 200) {
        event.preventDefault()
        this.editNoteError = '*Maximum length of 200 characters.'
      } else {
        this.editNoteError = ''
      }
    },
    updateVin () {
      let blackListreason
      if(this.editSearchQuery=='Other') {
        blackListreason = this.editRemark
      }else {
        blackListreason = this.editSearchQuery
      }
      this.validateEditNote()
      // this.searchQuery = this.editRemark;
      if(!this.editNoteError){
        let sendData = {
        blacklistReason: blackListreason,
        blacklisted: true
      }
      httpcommon.put('/vinblacklist/updateVinDetails?id='+this.vinId,sendData)
    .then(response=>{
      this.searchVinInList = ''
      this.isDialog=false
      this.editDialog = false
      this.getBlacklist()
      this.searchQuery=''
      this.editRemark=''
      this.vinId=''
      this.searchVin=''
      this.enterNote=''
      this.isSuccess = true
      this.successType = 'updated'
      this.vinError = ''
      this.reasonError = ''
      this.noteError = ''
      setTimeout(()=>{
      this.isSuccess = false
    },2000)
    })
    .catch(error=>{
        this.editDialog = false
        this.errorslist.push(error)
        this.isDialog=false;
        this.editRemark=''
    })
      }
    },

    whiteList () {
      
      let sendData = {
        blacklistReason: "",
        blacklisted: false
      }

      httpcommon.put('/vinblacklist/updateVinDetails?id='+this.vinId,sendData)
    .then(response=>{
      this.searchVinInList = ''
      this.isWhiteDialog=false
      this.editDialog = false
      this.getBlacklist()
      this.searchVin = ''
      this.enterNote = ''
      this.searchQuery=''
      this.editRemark=''
      this.vinId=''
      this.isSuccess = true
      this.successType = 'whitelisted'
      this.vinError = ''
      this.reasonError = ''
      this.noteError = ''
      setTimeout(()=>{
      this.isSuccess = false
    },2000)
    })
    .catch(error=>{
        this.editDialog = false
        this.errorslist.push(error)
        this.isWhiteDialog=false
        this.editRemark=''
    })
    },
   async vinInList () {
      try {
        this.blackList = []
        this.isLoading = true
        const response = await httpcommon.get(
          `vinblacklist/filterVinList?type=blacklisted&vinNumber=${this.searchVinInList.toUpperCase()}&page=${this.currentPage-1}&size=${this.perPage}`)
        this.blackList = response.data
        this.isLoading = false
        this.rows = this.blackList.totalElements
      } catch (error) {
        this.errorslist.push(error)
        this.isLoading = false
      }
    },
    debounceInList: debounce(function () {
      this.currentPage = 1
      if (this.searchVinInList.trim() !== '') {
        this.vinInList()
      } else {
        this.getBlacklist()
      }
    }, 200),
    getBlacklist () {
      this.isLoading = true
      this.blackList = []
      httpcommon
        .get(`/vinblacklist/getAllVinList?type=blacklisted&page=${this.currentPage-1}&size=${this.perPage}`)
        .then((response) => {
          this.isLoading = false
          this.blackList = response.data
          this.rows = this.blackList.totalElements
        })
        .catch((e) => {
          this.errorslist.push(e)
          this.isLoading = false
        })
    },
    pagination () {
      if (this.searchVinInList.trim() !== '') {
        this.vinInList()
      } else {
        this.getBlacklist()
      }
    },
    closeSuccess () {
      this.isSuccess = false
    },
    clearSearch () {
      if(this.searchVinInList !== '') {
        this.searchVinInList = ''
        this.getBlacklist()
      }
    },
    retrieveData: function () {
      httpcommon
        .get('/userrole/')
        .then((response) => {
          this.userroles = response.data
        })
        .catch((e) => {
          this.errorslist.push(e)
        })
      httpcommon
        .get('/staticdata/status/')
        .then((response) => {
          this.status = response.data
        })
        .catch((e) => {
          this.errorslist.push(e)
        })
    },

    toggleAddVIN($event) {
      $event.preventDefault();
      this.$router.push({ path: '/addVin' });
    },

    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#employee').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.getBlacklist()
    this.myFunction()
    this.menuheight()
    document.addEventListener('click', this.handleClickOutside)
    
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped >
.my-component {
  text-align: center;
  color: #42b983;
}

.vinContainer {
  margin-left: 40px;
}
.addbtn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 51px;
  width: 100%;
  background-color: #1e90ff;
  /* /text-align: center; */
  color: #ffffff;
}

.btnContainer {
  padding-top: 30px;
}

.inputVin {
  height: 51px !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 21.28px !important;
  font: #9b9b9b !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  background-color: white !important;
}
.reasonList {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-radius: 8px;
  /* border: 1px solid #ccc; */
  background-color: #ffffff;
  /* max-height: 210px; */
  /* max-width: 356px; */
  width: 100%;
  /* overflow-y: auto !important; */
  padding: 0;
  margin: 0;
  list-style: none;
  box-shadow: -4px 6px 24.1px 0px #00000014;
  z-index: 1;
  padding: 12px;
}
.reasonList li {
  padding: 12px;
  cursor: pointer;
  border-radius: 4px;
  font: #000000;
  font-weight: 600;
  font-size: 16px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 21.28px;
}
.reasonList li:hover {
  background-color: #f4f6fa;
}
.editscroll {
  max-height: 190px;
  overflow-y: auto;
}
.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  cursor: pointer;
  max-width: 356px;
  box-shadow: -4px 6px 24.1px 0px #00000014;
  position: relative;
  padding-right: 24px; /* Adjust to make space for the arrow */
}

.custom-select:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-select option {
  padding: 12px;
  font-weight: 600;
  font-size: 16px;
  line-height: 21.28px;
}

.custom-select::after {
  content: '\25BC'; /* Unicode character for down arrow */
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #000000;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center !important;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 60vh !important;
  height: 50vh !important;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  position: relative;
  top: 30px;
  font-size: 20px;
  font-weight: 600;
  line-height: 26.6px;
  color: #000000;
}
.okBtn {
  position: relative;
  top: 35px;
  background-color: #ea2626;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  margin: auto;
}
.whiteListBtn {
  position: relative;
  top: 35px;
  background-color: #3AAD49;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  margin: auto;
}
.cancelBtn {
  position: relative;
  top: 40px;
  display: flex;
  justify-content: center;
  margin: auto;
  color: #6e8193;
}
.searchfield {
  border-radius: 8px !important;
  padding: 16px !important;
  background-color: #f4f6fa;
  height: 48px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 18.62px !important;
  color: #91a7bd !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}
.searchfield::placeholder {
  color: #91a7bd !important;
}
.searchLogo {
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
.search-container {
  position: relative;
  width: 100%;
}
.vehicleHeading {
  align-items: flex-start;
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 31.92px;
  margin-bottom: 0;
}
.tablecontainer {
  width: 100%;
  display: block;
  position: relative;
  top: 30px;
  padding-right: 40px !important;
}
.tablelist thead th {
  border-top: none;
  border-bottom: 1px solid #8c8c8c;
  color: #9b9b9b;
  /* font-weight: 600;
  font-size: 16px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; */
  /* line-height: 21.28px; */
}

.tablelist thead th,
tbody td {
  border-top: none;
  font-size: 16px;
  font-weight: 600 !important;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 21.28px;
}
tbody .first {
  color: #9b9b9b;
}
tbody .second {
  color: #000000;
  /* font-weight: 600px !important; */
}
tbody .third {
  font-weight: 400;
  width: 100%;
  word-wrap: break-word; /* Break long words */
  word-break: break-word; /* Break long words */
  overflow-wrap: break-word; /* Ensure the text wraps within the column */
}
tbody .fourth {
  position: relative;
  float: right;
  font-weight: 400;
}
.updatebutton {
  font-weight: bold;
  display: flex !important;
  align-items: center !important;
  text-align: end;
  justify-content: center;
  color: #000000;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: none;
  font-size: 18px;
  line-height: 1 !important;
  padding: 0 0 9px 0 !important;
  margin: 0 !important;
}
.updatebutton:hover {
  background-color: #1e90ff;
}
tbody tr {
  border-bottom: 1px solid #dbdbdb;
}
.dropList {
  position: absolute;
  top: 0;
  height: 94px !important;
  right: 45px;
  width: 140px;
  /* top: 80px;  */
  background-color: #ffffff;
  box-shadow: -8px 9px 41.2px 0px #00000014;
  padding: 10px;
  z-index: 1;
  border-radius: 8px;
  /* list-style: none; */
}
.dropList ul {
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 8px;
}
.dropList li {
  padding: 10px;
  cursor: pointer;
  border-radius: 4px;
  font-weight: 400;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  line-height: 21.28px;
  gap: 10px;
}
.dropList li:hover {
  background-color: #f4f6fa;
}
.modal {
  align-items: flex-start;
}
.editmodal-body .editmodal-Heading {
  display: inline;
  text-align: start;
  font-weight: 600;
  font-size: 20px;
  color: #000000;
  padding-top: 7px;
}
.editmodal-body label {
  display: block;
  text-align: start;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
}
.editmodal-body input,textarea,button {
  Padding: 15px 13px 15px 13px !important;
  margin-bottom: 15px;
}
.editmodal-body .saveBtn {
  display: block;
  width: 100%;
  height: 51px;
  background-color: #1E90FF;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: white;
  margin-top: 30px !important;
  margin-bottom: 30px;
}
.editmodal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  max-width: 70vh !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 90vh;
  border-radius: 16px;
  /* text-align: center; */
}
.crossBtn {
  border: none;
  background: transparent;
  padding: 0px !important;
  margin: 0 !important;
  width:10%;
  border-radius: 50%;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 16px !important;
  cursor: pointer;
  background: #dee2e6;
  padding-bottom: 3px !important;
}
.crossBtn:hover {
  background: #1E90FF;
  color: #FFFFFF;
}
.custom-input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}
.custom-input-container .dropdown-arrow {
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  /* width: 24px;  */
  /* height: 24px; */
}
.input-error {
  border-color: #EA2626;
}
.validationError {
  color: #EA2626;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 18.62px;
}
.customPagination ::v-deep .page-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none ;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9B9B9B;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005DF1;
  border-radius: 8px;
  color: #FFFFFF;
}

.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
.clearText {
  text-align: end;
  padding-right: 25px;
  margin: 0;
}
.clearText a {
  cursor: pointer;
  color: #91a7bd ;
  font-weight: 400;
  font-size: 13px;
  text-decoration: underline;
}
.clearText a:hover {
  
  color: #1e90ff;
}
@media screen and (max-width: 767px) {
  .tablelist {
  white-space: nowrap;
  }
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}

.addVIN {
  cursor: pointer;
  color: #1e90ff;
  text-decoration: underline;
}

.required:after {
  content: " *";
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
